import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { SharedService } from 'src/app/services/sharedService';
import { BaseComponent } from '../../base.component';

@Component({
  selector: 'rdf-rows',
  templateUrl: './rows.component.html',
  styleUrls: ['./rows.component.css']
})
export class RowsComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input() rows
  @Input() emittables
  stageRowKeys = []
  selectedPosition = -1
  errors = { rowExistsError: false }
  constructor(private sharedService: SharedService) {
    super()
  }

  ngOnInit() {
    this.sharedService.stageRowKeysSubject$.pipe(takeUntil(this.destroy$)).subscribe(rowKeys => {
      this.stageRowKeys = rowKeys
    })
  }

  ngOnDestroy(): void {
    super.ngOnDestroy()
  }

  moveRow(val, rowKey) {
    const currentIndex = this.rows.findIndex((row) => row.key === rowKey);
    const [objToMove] = this.rows.splice(currentIndex, 1);
    this.rows.splice(val, 0, objToMove);
  }

  createRow(row) {
    this.sharedService.setRowCreationError(null)
    if (!row.key) {
      let rowIndex = 1;
      while (this.stageRowKeys.includes(`row_${rowIndex}`)) {
        rowIndex++;
      }
      row.key = `row_${rowIndex}`
    }
    else {
      if (this.stageRowKeys.includes(row.key)) {
        this.errors.rowExistsError = true
        this.sharedService.setRowCreationError(this.errors)
        return;
      }
    }
    this.rows.splice(this.selectedPosition, 0, row)
    setTimeout(() => {
      this.selectedPosition = this.selectedPosition + 1
    })

    this.stageRowKeys.push(row.key)
    this.sharedService.setStageKeys(this.stageRowKeys)
  }
  insertAtPosition(rowPosition) {

    if (this.selectedPosition === rowPosition) {
      this.selectedPosition = -1
      return
    }
    this.selectedPosition = rowPosition
  }
}
